import { ViewField } from "@/components/field";
import { formatDateForDisplay } from "@/lib/utils";
import { RenderProfile } from "components/render-profile";

export default function TimesheetViewContent({
  entryData,
  showEmployee = false,
}) {
  if (!entryData) return null;

    return (
        <div className="p-6 grid md:grid-cols-10 grid-cols-1 md:h-full gap-4 md:gap-6 flex-1">
            <div className="md:col-span-4 flex flex-col gap-4 md:border-r md:border-solid">
                {showEmployee && (
                    <ViewField value={<RenderProfile user={entryData.employee} />} />
                )}
                <ViewField label="Date" value={formatDateForDisplay(entryData.date)} />
                <ViewField label="Project" value={entryData.project.name} />
                <ViewField label="Job" value={entryData.job.name} />
                <ViewField label="Milestone" value={entryData.milestone?.name} />
                <ViewField label="Tag" value={entryData.tag?.label} />
                <ViewField label="Hours" value={entryData.logged_hours} />
                <ViewField
                    label="Approved"
                    value={
                        (entryData.approved_hours || entryData.unapproved_hours) &&
                        entryData.approved_hours
                    }
                />
                <ViewField
                    label="Unapproved"
                    value={
                        (entryData.approved_hours || entryData.unapproved_hours) &&
                        entryData.unapproved_hours
                    }
                />
                    <ViewField
                        label="Reason"
                        value={entryData.reason}
                        className={"whitespace-pre-wrap"}
                    />
            </div>
            <div className="md:col-span-6">
                <ViewField
                    label="Description"
                    value={entryData?.description}
                    className={"whitespace-pre-wrap"}
                />
            </div>
        </div>
    );
}
